const Home = () => (
  <div className="main">
    <div className="container hero-section mt-5">
      <div className="row">
        <div className="col-sm-12 col-md-6 col-lg-6">
          <div className="hero-title mb-3" data-aos="zoom-in" data-aos-duration="500" data-aos-once="true">
            I&apos;m Muhammad Aleem Hashmi
            <br />
            Glad to see you!
          </div>

          <p className="mb-5" data-aos="fade-right" data-aos-duration="500" data-aos-once="true">
            I&apos;m a software developer! I can help you build a product,
            feature or website. Look through some of my work and experience! If
            you like what you see and have a project you need coded, don’t
            hesitate to contact me.
          </p>

          <a href="/contact" className="btn btn-primary">
            Let&apos;s Connect
          </a>
        </div>
      </div>
    </div>
  </div>
);

export default Home;
